import React, { useEffect, useState } from "react";
import { Link } from "gatsby";
import NavLinkDesktop from "./NavLinkDesktop";

const NavDesktop = ({ linkData, currentTab, setCurrentTab }) => {
  const [menuDropdown, setMenuDropdown] = useState(false);
  const { isLink, title } = linkData;
  useEffect(()=>{
    if(menuDropdown===false){
setCurrentTab("");
    }else{
      setCurrentTab(title)
    }
  },[menuDropdown])
  const toggleHover = () => setMenuDropdown(!menuDropdown);
  return isLink ? (
    <Link to={`${linkData.link}`} title={`${title} page link`} noPrefetch>{title}</Link>
  ) : (
    <div
      className={`dropdown-nav-container desktop ${
        menuDropdown && currentTab === title ? "dropdown-on" : ""
      }`}
      onMouseEnter={toggleHover}
      onMouseLeave={toggleHover}
    >
      <div
        className={`st-root-link nav-link dropdown-nav-title desktop ${
          menuDropdown && currentTab === title ? "active" : ""
        }`}
      >
        {title}
        <i className="fas fa-angle-down angle"></i>
      </div>
      <ul className="nav-sub-menu">
        {linkData.linksList.map((data, index) => (
          <NavLinkDesktop key={index} linkData={data} />
        ))}
      </ul>
    </div>
  );
};

export default NavDesktop;
